module.exports = __webpack_public_path__ + "static/media/trioultimeen.de922a31.png";